export enum Granularity {
  Monthly = 'MONTHLY',
  Daily = 'DAILY',
  None = 'NONE',
}
